import { type FC, type ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { OFFER_PROMOTION_TYPE } from '../../../../offer'
import { ProductSearchFlag } from '../../ProductSearchFlag'

import { type ProductSearchResultItemLabel } from './useProductSearchResultItemLabels'

const getPromotionLabelByPromotionType = (
  promotionType: OFFER_PROMOTION_TYPE,
): ReactElement | null => {
  switch (promotionType) {
    case OFFER_PROMOTION_TYPE.BUNDLE: {
      return (
        <ProductSearchFlag className="border-light-primary-strong bg-light-brand-medium">
          <FormattedMessage id="general.label.product.bundle" />
        </ProductSearchFlag>
      )
    }
    case OFFER_PROMOTION_TYPE.FREEBIE: {
      return (
        <ProductSearchFlag className="border-dark-primary-min bg-light-primary-low">
          <FormattedMessage id="general.label.product.freebie" />
        </ProductSearchFlag>
      )
    }
    case OFFER_PROMOTION_TYPE.ONE_FOR_ONE:
    case OFFER_PROMOTION_TYPE.ONE_PLUS_ONE: {
      return (
        <ProductSearchFlag className="border-dark-primary-min bg-light-primary-low">
          <FormattedMessage id="general.label.product.oneforone" />
        </ProductSearchFlag>
      )
    }
    default: {
      return null
    }
  }
}

export const ProductSearchResultItemPromotionLabelRenderer: FC<{
  label: ProductSearchResultItemLabel
}> = ({ label }) => {
  const promotionType = label.promotionSpecific?.promotionType
  if (!promotionType) {
    return null
  }

  return getPromotionLabelByPromotionType(promotionType)
}
